<template>
    <div id="newGroup">
        <h5>创建一个检查应用</h5>
        <el-button icon="el-icon-plus" type="primary" @click="dialogFormVisible = true">新建检查应用</el-button>
        <el-dialog title="创建检查应用" :visible.sync="dialogFormVisible">
            
                    <el-form :model="app">
                        <el-form-item label="检查应用名称">
                            <el-input v-model="app.app_name"></el-input>
                        </el-form-item>
                        <el-form-item label="检查频率">
                            <el-radio-group v-model="app.frequency">
                                <el-radio label="只能检查一次"></el-radio>
                                <el-radio label="每天检查一次"></el-radio>
                                <el-radio label="每天检查多次"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="公开查询">
                            <el-switch v-model="app.is_public_query">
                            </el-switch>
                        </el-form-item>
                        
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="onSubmit">确定</el-button>
                    </div>
             
        </el-dialog>
        <el-table :data="jiancha_apps" height="350" style="width: 100%">
            <el-table-column label="应用名称" width="250">
                <template slot-scope="scope">
                    <span>{{ scope.row.app_name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="检查发布">
                <template slot-scope="scope">
                    <el-button size="mini" icon='el-icon-share' circle @click="pageToFabu(scope.row)"></el-button>
                </template>
            </el-table-column>
            <el-table-column label="管理设置">
                <template slot-scope="scope">
                    <el-button size="mini" icon='el-icon-arrow-right' circle @click="pageToSetting(scope.row)"></el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import axios from 'axios';
import config from '../config.js';
export default {
    data() {
        return {
            app: {
                app_name: '',
                frequency: '只能检查一次',
                is_public_query: false
            },

            new_app: null,
            jiancha_apps: [],
            dialogFormVisible: false
        }
    },
    created() {
        this.checkLogin()
    },
    methods: {
        checkLogin() {
            let url = config.base_url + '/yun_table/users/islogin';
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                let res = response.data;
                if (res.login) {
                    console.log('login true');
                    this.getJanchaApps()
                } else {
                    console.log('login false');
                    this.$router.push({
                        'path': '/login'
                    })
                }
            })


        },
        getJanchaApps() {
            let _this = this;
            axios.get(config.base_url + '/yun_table/yun_jiancha/apps', {
                    headers: {
                        "Authorization": localStorage.getItem('token')
                    }
                })
                .then(function(response) {
                    _this.jiancha_apps = response.data;
                });
        },
        onSubmit() {
            let app = this.app;
            let _this = this;
            if (!app.app_name) {
                this.$message({
                    message: '请输入检查应用名称',
                    type: 'warning'
                });
            } else {
            	if(app.frequency == '只能检查一次'){
            		var frequency = '1'
            	}
            	if(app.frequency == '每天检查一次'){
            		var frequency = '2'
            	}
            	if(app.frequency == '每天检查多次'){
            		var frequency = '3'
            	}
            	if(app.is_public_query){
            		var is_public_query = '2'
            	}else{
            		var is_public_query = '1'
            	}
            	let data = {
            		app_name: app.app_name,
            		frequency: frequency,
            		is_public_query: is_public_query
            	}
                axios({
                        method: 'post',
                        url: config.base_url + '/yun_table/yun_jiancha/apps',
                        headers: {
                            "Authorization": localStorage.getItem('token')
                        },
                        data: data
                    })
                    .then(function(response) {
                        //console.log(response)
                        _this.new_app = response.data
                        localStorage.setItem(response.data.app_id, JSON.stringify(response.data))
                        _this.$message({
                            message: '检查应用创建成功',
                            type: 'success'
                        });
                        _this.$router.push({
                        	name:'newjcdx',
                        	params:{
                        		app_id: response.data.app_id
                        	}
                        })
                    })
                    .catch((err) => {
                        //console.log(err.response)
                        let err_data = err.response.data.err_msg
                        this.$message({
                            message: err_data,
                            type: 'error'
                        })
                    })
            }
        },
        
        pageToFabu(app) {
            //console.log(group.group_id)
            this.$router.push({
                name: 'jianchafabu',
                params: {
                    app_id: app.app_id
                }
            })
        },

        pageToSetting(app) {
            this.$router.push({
                name: 'jianchasetting',
                params: {
                    app_id: app.app_id,
                    app_name: app.app_name
                }
            })
        }


    }

}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#newGroup h5 {
    margin-top: 30px;
    margin-bottom: 30px;
}
</style>